import type { LoginParams, LoginResult } from '@/domain/auth/Auth'
import type { AuthRepository } from '@/domain/auth/AuthRepository'
import { API_PATHS } from '@/infrastructure/http/ApiPaths'
import type { HttpClient } from '@/infrastructure/interfaces/HttpClient'
import { toLoginResult } from '@/infrastructure/mapper/ApiToDomainMapper'

export class HttpAuthRepository implements AuthRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async login(params: LoginParams): Promise<LoginResult> {
    const response = await this.httpClient.request({
      path: API_PATHS.AUTH.LOGIN,
      method: 'POST',
      body: {
        agent_name: params.agentName.trim(),
        password: params.password,
      },
    })
    return toLoginResult(response)
  }
}
